import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { fontRoboto, fontSourceSerif4, theme } from "shared/lib/styles";

import { EntityOnelineMenuLite } from "scmp-app/components/entity-oneline-menu-lite";
import {
  StyledSwiper,
  StyledSwiperSlide,
} from "scmp-app/components/entity-oneline-menu-lite/styles";
import { VideoLatestVideo } from "scmp-app/components/video/latest-video";
import { VideoHeaderDropdownMenu } from "scmp-app/components/video/video-header-dropdown-menu";
import { VideoList } from "scmp-app/components/video/video-list";
import { VideoShortCarousel } from "scmp-app/components/video/video-short-carousel";

export const Container = styled.div`
  display: grid;
  grid:
    "header" min-content
    "latest-video" min-content
    "latest-shorts" min-content
    "all-videos" min-content
    / 100%;

  max-inline-size: 1272px;
  margin-inline: auto;
`;

export const Header = styled.div`
  grid-area: header;

  display: grid;
  grid:
    "section-name" min-content
    "one-line-menu" min-content
    / auto;

  margin-block-start: 20px;

  ${theme.breakpoints.up("tablet")} {
    margin-block-start: 32px;
  }

  ${theme.breakpoints.up("desktop")} {
    padding-inline: 32px;
  }
`;

export const SectionNameContainer = styled.div`
  grid-area: section-name;

  display: flex;
  justify-content: space-between;
  align-items: center;

  ${theme.breakpoints.up("tablet")} {
    column-gap: 16px;
    justify-content: flex-start;
  }
`;

export const OneLineMenuContainer = styled.div`
  grid-area: one-line-menu;

  display: flex;

  margin-block-start: 16px;

  ${theme.breakpoints.up("tablet")} {
    column-gap: 20px;
    align-items: center;
  }
`;

export const SectionName = styled.div`
  grid-area: section-name;

  font-weight: 400;
  font-size: 32px;
  font-family: ${fontSourceSerif4};
  font-style: normal;
  line-height: 90%;
  letter-spacing: -1.28px;
  text-transform: uppercase;

  ${theme.breakpoints.up("tablet")} {
    font-size: 48px;
    letter-spacing: -1.92px;
  }

  ${theme.breakpoints.up("desktop")} {
    font-size: 64px;
    letter-spacing: -2.56px;
  }
`;

const entityOnelineMenuLiteSwiperStyles = css`
  ${StyledSwiper} {
    .swiper-wrapper {
      block-size: 100%;
    }

    ${StyledSwiperSlide}:first-of-type {
      color: #000000;
      font-weight: 700;
      font-size: 14px;
      font-family: ${fontRoboto};
      font-style: normal;
      line-height: 140%;

      ${theme.breakpoints.only("mobile")} {
        display: none;
      }
    }

    ${StyledSwiperSlide}:not(:last-child) {
      margin-inline-end: 20px;
    }
  }
`;

export const StyledEntityOnelineMenuLite = styled(EntityOnelineMenuLite)`
  min-inline-size: 0;

  ${entityOnelineMenuLiteSwiperStyles}

  ${theme.breakpoints.only("mobile")} {
    display: none;
  }
`;

export const StyledVideoHeaderDropdownMenu = styled(VideoHeaderDropdownMenu)`
  ${theme.breakpoints.only("mobile")} {
    inline-size: 100%;
  }
`;

export const StyledVideoLatestVideo = styled(VideoLatestVideo)`
  grid-area: latest-video;

  margin-block-start: 20px;

  ${theme.breakpoints.up("tablet")} {
    margin-block-start: 32px;
  }
`;

export const StyledVideoShortCarousel = styled(VideoShortCarousel)`
  grid-area: latest-shorts;

  ${theme.breakpoints.only("mobile")} {
    padding-block: 0;
  }

  ${theme.breakpoints.up("tablet")} {
    margin-block-start: 32px;
  }

  ${theme.breakpoints.up("desktop")} {
    margin-inline: 32px;
  }
`;

export const StyledVideoList = styled(VideoList)`
  grid-area: all-videos;

  margin-block-start: 20px;

  ${theme.breakpoints.up("tablet")} {
    margin-block-start: 32px;
  }

  ${theme.breakpoints.up("desktop")} {
    margin-inline: 32px;
  }
`;
